/* Behaviour for the knife guides page: the sticky step bar, and nothing
   else. Every other section on the page is plain markup with no script.

   It is a custom element, so it sets itself up again whenever the theme
   editor re-renders a section. Without JavaScript the bar stays hidden and
   the page still works. */

if (!customElements.get('guides-steps')) {
  /* Builds its links from every section on the page marked data-guides-step,
     in page order, so adding, removing or reordering step sections in the
     editor updates the bar with no settings to keep in sync. */
  class GuidesSteps extends HTMLElement {
    connectedCallback() {
      this.build = this.build.bind(this);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.build();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      document.addEventListener('shopify:section:load', this.build);
      this.onUnload = () => setTimeout(this.build);
      document.addEventListener('shopify:section:unload', this.onUnload);
      document.addEventListener('shopify:section:reorder', this.build);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.build);
      document.removeEventListener('shopify:section:unload', this.onUnload);
      document.removeEventListener('shopify:section:reorder', this.build);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    build() {
      const list = this.querySelector('[data-steps-list]');
      if (!list) return;
      const targets = [...document.querySelectorAll('[data-guides-step]')].filter(
        (el) => el.id && el.dataset.guidesStep
      );
      list.replaceChildren();
      this.targets = [];
      this.links = [];
      this.classList.toggle('is-ready', targets.length > 1);
      if (targets.length < 2) return;

      const links = targets.map((el, i) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${el.id}`;
        if (el.dataset.guidesNumbered !== 'false') {
          const b = document.createElement('b');
          b.textContent = String(i + 1);
          a.append(b);
        }
        a.append(document.createTextNode(el.dataset.guidesStep));
        li.append(a);
        list.append(li);
        return a;
      });

      // The current step is the last one whose top has passed a line a third
      // of the way down the window. Worked out from positions on every
      // scroll, so a jump straight from one end of the page to the other
      // can't leave the wrong step highlighted.
      this.targets = targets;
      this.links = links;
      this.update();
    }

    update() {
      if (!this.targets?.length) return;
      const line = window.innerHeight / 3;
      let index = 0;
      this.targets.forEach((el, i) => {
        if (el.getBoundingClientRect().top <= line) index = i;
      });
      this.links.forEach((a, i) => a.setAttribute('aria-current', i === index ? 'true' : 'false'));
    }
  }
  customElements.define('guides-steps', GuidesSteps);
}
